import api from "@Api/index";
import Factory from "@Shared/Factory";
export const get = () => api
    .get("/actions")
    .then((result) => result.data.map(({ item }) => Factory.Action(item)));
